export default __webpack_public_path__ + "static/media/icoLose.8e6fb86f.png";